import React from 'react';
import { Container, Grid } from '@material-ui/core';

import css from './Toolbar.module.css';
import Logo from '../../UI/Logo/Logo';
import NavigationItems from '../NavigationItems/NavigationItems';

const Toolbar = () => (
    <header className={css.Toolbar}>
        <Container>
            <Grid
                container
                justify="space-between"
                alignItems="center">
                <Logo />
                <NavigationItems />
            </Grid>
        </Container>
    </header>
);

export default Toolbar;